export {
  mallApi,
  mallDomainApi,
  mallFeDomainApi,
  mallEntranceDomainApi
} from './modules/mallApi'
export { mallTradeApi } from './modules/mallTradeApi'
export { mallEntranceApi } from './modules/mallEntranceApi'
export { tpPayApi } from './modules/tpPayApi'
export { tradegwApi } from './modules/tradegw'
